import React, { useEffect, useState } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { ButtonIcon, DropBox, ImageComponent, InputBox, Uploader } from "..";
import TabPane from "antd/es/tabs/TabPane";
import { message, Progress, Tabs } from "antd";
import { deleteImage } from "../imageComponent/service/upload.service";
import { CheckValidity } from "../../utils/formValidity";
import { useSelector } from "react-redux";
import ImageGenerateAI from "../../containers/templates/imageGenerateAI";

const Index = ({
  data,
  setImageList,
  setImageListRight,
  onChange,
  setTabName,
  setLogo,
  setBanner,
  setGif,
  setGifRight,
}) => {
  const [isExpanded, setIsExpanded] = useState("");
  const [image, setImage] = useState([]);
  const [rightImage, setRightImage] = useState([]);
  const [bannerImage, setBannerImage] = useState("");
  const [bannerLogoImage, setBannerLogoImage] = useState("");
  const [gifImage, setGifImage] = useState("");
  const [gifImageRight, setGifImageRight] = useState("");
  const [uploadSectionState, setUploadSectionState] = useState({});

  const updateUploadSectionState = (sectionKey, updates) => {
    setUploadSectionState((prev) => ({
      ...prev,
      [sectionKey]: {
        ...(prev[sectionKey] || {}),
        ...updates,
      },
    }));
  };

  const getUploadSectionState = (sectionKey) =>
    uploadSectionState[sectionKey] || {
      isLoading: false,
      uploadProgress: 0,
    };

  const [formData, setFormData] = useState({
    destinationURL: {
      key: "destinationURL",
      label: "Destination URL",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
        url: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    title: {
      key: "title",
      label: "Title",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
        maxLength: 20,
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    description: {
      key: "description",
      label: "Description",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
        maxLength: 80,
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    buttonType: {
      key: "buttonType",
      label: "Button Type",
      size: "sm",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [
          {
            key: "More",
            value: "More",
            displayValue: "More",
          },
          {
            key: "Learn More",
            value: "Learn More",
            displayValue: "Learn More",
          },
          {
            key: "Click",
            value: "Click",
            displayValue: "Click",
          },
          {
            key: "Visit",
            value: "Visit",
            displayValue: "Visit",
          },
          {
            key: "Contact us",
            value: "Contact us",
            displayValue: "Contact us",
          },
        ],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { advertisement } = useSelector(
    ({ adsCampaignReducer }) => adsCampaignReducer,
  );

  const MAX_IMAGES = 3;
  const MAX_IMAGES_RIGHT = 3;

  const tabJson = [
    {
      id: 1,
      key: 1,
      tabName: "Image Ad",
      // content: <AllOrders />,
    },
    {
      id: 2,
      key: 2,
      tabName: "Text + banner Combo",
      // content: <ShippingOrders />,
    },
    {
      id: 3,
      key: 3,
      tabName: "GIF",
      // content: <CompletedOrders />,
    },
  ];

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation,
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateForm);
    }
  };

  const toggleDetails = () => {
    setIsExpanded((prev) => !prev);
  };

  const onChangeTab = (key) => {
    if (key === "2") {
      console.log({ key });
      setTabName(true);
    }
  };

  const onChangeBannerLogo = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          file_name: image.file_name,
        };

        setBannerLogoImage(file);
        setTabName(true);
        setLogo(file);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onChangeBannerImage = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          file_name: image.file_name,
        };

        setBannerImage(file);
        setBanner(file);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onChangeGif = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          file_name: image.file_name,
        };

        setGifImage(file);
        setGif(file);
        // setImageList((prev) => [...prev, file].slice(0, MAX_IMAGES));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onChangeGifRight = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          file_name: image.file_name,
        };

        setGifImageRight(file);
        setGifRight(file);
        // setImageListRight((prev) => [...prev, file].slice(0, MAX_IMAGES_RIGHT));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onChangeImage = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          file_name: image.file_name,
        };

        setImage((prev) => [...prev, file].slice(0, MAX_IMAGES));
        setImageList((prev) => [...prev, file].slice(0, MAX_IMAGES));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onChangeRightImage = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          file_name: image.file_name,
        };

        setRightImage((prev) => [...prev, file].slice(0, MAX_IMAGES_RIGHT));
        setImageListRight((prev) => [...prev, file].slice(0, MAX_IMAGES_RIGHT));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onClickRemoveImage = async (key, type, adType, index) => {
    try {
      const RemoveImage = await deleteImage(key);
      console.log("remove image", RemoveImage?.data?.status);
      if (RemoveImage?.data?.status) {
        console.log("Image Deleted");
        if (adType === "ad") {
          if (type === "right") {
            setRightImage((prev) => prev.filter((_, i) => i !== index));
            setImageListRight((prev) => prev.filter((_, i) => i !== index));
          } else {
            setImage((prev) => prev.filter((_, i) => i !== index));
            setImageList((prev) => prev.filter((_, i) => i !== index));
          }
        }
        if (adType === "banner") {
          setBannerImage("");
          setBanner("");
        }

        if (adType === "bannerLogo") {
          setBannerLogoImage("");
          setLogo("");
        }
        if (adType === "gif") {
          setGifImage("");
          setGif("");
          // setImageList((prev) => prev.filter((i) => i.file_name !== key));
        }
        if (adType === "gifRight") {
          setGifImageRight("");
          setGifRight("");
          // setImageListRight((prev) => prev.filter((i) => i.file_name !== key));
        }
        message.success("Image Deleted");
      } else {
        console.log("Deleted Fail");
      }
    } catch (error) {
      console.log("Error in deleting image", error);
      message.error("Error in deleting image");
    }
  };

  useEffect(() => {
    onChange(formData);
  }, [formData]);

  useEffect(() => {
    // ad_space: adSpaceType,
    // header_banner_img: previewImages,
    // right_banner_img: previewImagesRight,
    // text_banner_logo: logoImage?.url,
    // text_banner_img: bannerImage ? [bannerImage] : [],
    // header_gif: gifImage ? [gifImage] : [],
    // right_gif: gifImageRight ? [gifImageRight] : [],
    // title: updateForm.title.value,
    // description: updateForm.description.value,
    // button_type: updateForm.buttonType.value,
    // web_ur

    const newFormData = { ...formData };

    if (advertisement?.header_banner_img) {
      setImage(advertisement?.header_banner_img);
    }
    if (advertisement?.right_banner_img) {
      setRightImage(advertisement?.right_banner_img);
    }
    if (advertisement?.text_banner_logo !== "") {
      setBannerLogoImage(advertisement?.text_banner_logo);
    }
    if (advertisement?.text_banner_img?.length > 0) {
      setBannerImage(advertisement?.text_banner_img?.[0]);
    }
    if (advertisement?.header_gif?.length > 0) {
      setGifImage(advertisement?.header_gif?.[0]);
    }
    if (advertisement?.right_gif?.length > 0) {
      setGifRight(advertisement?.right_gif?.[0]);
    }

    if (advertisement?.web_url !== "") {
      newFormData["destinationURL"].value = advertisement?.web_url;
    }

    if (advertisement?.title !== "") {
      newFormData["title"].value = advertisement?.title;
    }
    if (advertisement?.description !== "") {
      newFormData["description"].value = advertisement?.description;
    }
    if (advertisement?.button_type !== "") {
      newFormData["buttonType"].value = advertisement?.button_type;
    }
    setFormData(newFormData);
  }, [advertisement]);

  const updateForm = { ...formData };
  const gifRightUploadState = getUploadSectionState("gifRight");
  const gifHeaderUploadState = getUploadSectionState("gifHeader");

  return (
    <>
      {/* <div className="web-uploader-card-wrapper"> */}
      <div className="wpcw-heading-wrapper">
        <div className="wpcw-title">{data?.title}</div>

        <ButtonIcon
          data={{
            iconName: "arrow-down",
            size: "xl",
            type: "light",
          }}
          onClick={toggleDetails}
        />
      </div>
      {isExpanded && (
        <>
          <div className="wpcw-content-wrapper">
            <Tabs onChange={onChangeTab}>
              {((tabJson && tabJson) || [])
                .filter((_, index) => {
                  // Exclude second tab (index 1) only if data?.type === "header"
                  if (data?.type === "header" && index === 1) return false;
                  return true;
                })
                .map((i, t) => (
                  <TabPane tab={i.tabName} key={i.key}>
                    {i.key === 1 && (
                      <>
                        {!data?.isAdmin && <ImageGenerateAI />}
                        {data?.type === "header" && (
                          <>
                            <div className="wpcw-sub-title">
                              Recommended size: 728 x 90 pixels · Accepted
                              formats: JPG, GIF PNG · Max size: 6MB
                            </div>

                            <div
                              className={
                                "d-flex flex-row align-items-center mt-3 "
                              }
                              style={{
                                gap: "15px",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {image && image?.[0] && (
                                <ImageComponent
                                  // key={index}
                                  data={{
                                    size: "header-ad-lg mb-2",
                                    imgUrl: image?.[0]?.url,
                                  }}
                                  onClickRemove={() =>
                                    onClickRemoveImage(
                                      image?.[0]?.file_name,
                                      "header",
                                      "ad",
                                      0,
                                    )
                                  }
                                />
                              )}

                              {!image?.[0] && (
                                <div
                                  key={`placeholder`}
                                  className="header-bar-adv-wrapper flex items-center justify-center text-gray-400"
                                >
                                  Ad 720x90
                                </div>
                              )}

                              {!image?.[0] && (
                                <Uploader
                                  data={{
                                    disabled: false,
                                    isLable: true,
                                    iconName: "upload-cloud",
                                    width: 720,
                                    height: 90,
                                    fileSize: 6,
                                  }}
                                  onChange={onChangeImage}
                                  loading={(value) =>
                                    updateUploadSectionState("headerAd1", {
                                      isLoading: value,
                                      uploadProgress: value ? 0 : 100,
                                    })
                                  }
                                  progress={(value) =>
                                    updateUploadSectionState("headerAd1", {
                                      isLoading: true,
                                      uploadProgress: value,
                                    })
                                  }
                                />
                              )}
                            </div>
                            <div
                              className={"d-flex flex-row align-items-center "}
                              style={{ gap: "15px", justifyContent: "center" }}
                            >
                              {image && image?.[1] && (
                                <ImageComponent
                                  // key={index}
                                  data={{
                                    size: "header-ad-lg mb-2",
                                    imgUrl: image?.[1]?.url,
                                  }}
                                  onClickRemove={() =>
                                    onClickRemoveImage(
                                      image?.[1]?.file_name,
                                      "header",
                                      "ad",
                                      1,
                                    )
                                  }
                                />
                              )}
                              {!image?.[1] && (
                                <div
                                  key={`placeholder`}
                                  className="header-bar-adv-wrapper flex items-center justify-center text-gray-400"
                                >
                                  Ad 720x90
                                </div>
                              )}

                              {!image?.[1] && (
                                <Uploader
                                  data={{
                                    disabled: false,
                                    isLable: true,
                                    iconName: "upload-cloud",
                                    width: 620,
                                    height: 620,
                                    fileSize: 6,
                                  }}
                                  onChange={onChangeImage}
                                  loading={(value) =>
                                    updateUploadSectionState("headerAd2", {
                                      isLoading: value,
                                      uploadProgress: value ? 0 : 100,
                                    })
                                  }
                                  progress={(value) =>
                                    updateUploadSectionState("headerAd2", {
                                      isLoading: true,
                                      uploadProgress: value,
                                    })
                                  }
                                />
                              )}
                            </div>
                            <div
                              className={"d-flex flex-row align-items-center "}
                              style={{ gap: "15px", justifyContent: "center" }}
                            >
                              {image && image?.[2] && (
                                <ImageComponent
                                  // key={index}
                                  data={{
                                    size: "header-ad-lg mb-2",
                                    imgUrl: image?.[2]?.url,
                                  }}
                                  onClickRemove={() =>
                                    onClickRemoveImage(
                                      image?.[2]?.file_name,
                                      "header",
                                      "ad",
                                      2,
                                    )
                                  }
                                />
                              )}

                              {!image?.[2] && (
                                <div
                                  key={`placeholder`}
                                  className="header-bar-adv-wrapper flex items-center justify-center text-gray-400"
                                >
                                  Ad 720x90
                                </div>
                              )}

                              {!image?.[2] && (
                                <Uploader
                                  data={{
                                    disabled: false,
                                    isLable: true,
                                    iconName: "upload-cloud",
                                    width: 620,
                                    height: 620,
                                    fileSize: 6,
                                  }}
                                  onChange={onChangeImage}
                                  loading={(value) =>
                                    updateUploadSectionState("headerAd3", {
                                      isLoading: value,
                                      uploadProgress: value ? 0 : 100,
                                    })
                                  }
                                  progress={(value) =>
                                    updateUploadSectionState("headerAd3", {
                                      isLoading: true,
                                      uploadProgress: value,
                                    })
                                  }
                                />
                              )}
                            </div>
                            {!data?.isAdmin && (
                              <InputBox
                                data={updateForm.destinationURL}
                                onChange={async (e) => {
                                  e.preventDefault();
                                  await handleChange(
                                    e.target.value,
                                    updateForm.destinationURL.key,
                                  );
                                }}
                              />
                            )}
                          </>
                        )}
                        {data?.type === "slider" && (
                          <>
                            <div className="wpcw-sub-title">
                              Recommended size: 620 x 620 pixels · Accepted
                              formats: JPG, GIF PNG · Max size: 6MB
                            </div>

                            <div
                              className={
                                "d-flex flex-row align-items-center mt-3 "
                              }
                              style={{ gap: "15px", justifyContent: "end" }}
                            >
                              {rightImage && rightImage?.[0] && (
                                <ImageComponent
                                  // key={index}
                                  data={{
                                    size: "right-adv mb-2",
                                    imgUrl: rightImage?.[0]?.url,
                                  }}
                                  onClickRemove={() =>
                                    onClickRemoveImage(
                                      rightImage?.[0]?.file_name,
                                      "right",
                                      "ad",
                                      0,
                                    )
                                  }
                                />
                              )}

                              {!rightImage?.[0] && (
                                <div
                                  key={`placeholder`}
                                  className="right-bar-adv-wrapper flex items-center justify-center text-gray-400"
                                >
                                  Ad 620x620
                                </div>
                              )}

                              {!rightImage?.[0] && (
                                <Uploader
                                  data={{
                                    disabled: false,
                                    isLable: true,
                                    iconName: "upload-cloud",
                                    width: 620,
                                    height: 620,
                                    fileSize: 6,
                                  }}
                                  onChange={onChangeRightImage}
                                  loading={(value) =>
                                    updateUploadSectionState("sliderAd1", {
                                      isLoading: value,
                                      uploadProgress: value ? 0 : 100,
                                    })
                                  }
                                  progress={(value) =>
                                    updateUploadSectionState("sliderAd1", {
                                      isLoading: true,
                                      uploadProgress: value,
                                    })
                                  }
                                />
                              )}
                            </div>
                            <div
                              className={"d-flex flex-row align-items-center "}
                              style={{ gap: "15px", justifyContent: "end" }}
                            >
                              {rightImage && rightImage?.[1] && (
                                <ImageComponent
                                  // key={index}
                                  data={{
                                    size: "right-adv mb-2",
                                    imgUrl: rightImage?.[1]?.url,
                                  }}
                                  onClickRemove={() =>
                                    onClickRemoveImage(
                                      rightImage?.[1]?.file_name,
                                      "right",
                                      "ad",
                                      1,
                                    )
                                  }
                                />
                              )}

                              {!rightImage?.[1] && (
                                <div
                                  key={`placeholder`}
                                  className="right-bar-adv-wrapper flex items-center justify-center text-gray-400"
                                >
                                  Ad 620x620
                                </div>
                              )}

                              {!rightImage?.[1] && (
                                <Uploader
                                  data={{
                                    disabled: false,
                                    isLable: true,
                                    iconName: "upload-cloud",
                                    width: 620,
                                    height: 620,
                                    fileSize: 6,
                                  }}
                                  onChange={onChangeRightImage}
                                  loading={(value) =>
                                    updateUploadSectionState("sliderAd2", {
                                      isLoading: value,
                                      uploadProgress: value ? 0 : 100,
                                    })
                                  }
                                  progress={(value) =>
                                    updateUploadSectionState("sliderAd2", {
                                      isLoading: true,
                                      uploadProgress: value,
                                    })
                                  }
                                />
                              )}
                            </div>
                            <div
                              className={"d-flex flex-row align-items-center "}
                              style={{ gap: "15px", justifyContent: "end" }}
                            >
                              {rightImage && rightImage?.[2] && (
                                <ImageComponent
                                  // key={index}
                                  data={{
                                    size: "right-adv mb-2",
                                    imgUrl: rightImage?.[2]?.url,
                                  }}
                                  onClickRemove={() =>
                                    onClickRemoveImage(
                                      rightImage?.[2]?.file_name,
                                      "right",
                                      "ad",
                                      2,
                                    )
                                  }
                                />
                              )}

                              {!rightImage?.[2] && (
                                <div
                                  key={`placeholder`}
                                  className="right-bar-adv-wrapper flex items-center justify-center text-gray-400"
                                >
                                  Ad 620x620
                                </div>
                              )}

                              {!rightImage?.[2] && (
                                <Uploader
                                  data={{
                                    disabled: false,
                                    isLable: true,
                                    iconName: "upload-cloud",
                                    width: 620,
                                    height: 620,
                                    fileSize: 6,
                                  }}
                                  onChange={onChangeRightImage}
                                  loading={(value) =>
                                    updateUploadSectionState("sliderAd3", {
                                      isLoading: value,
                                      uploadProgress: value ? 0 : 100,
                                    })
                                  }
                                  progress={(value) =>
                                    updateUploadSectionState("sliderAd3", {
                                      isLoading: true,
                                      uploadProgress: value,
                                    })
                                  }
                                />
                              )}
                            </div>

                            {!data?.isAdmin && (
                              <InputBox
                                data={updateForm.destinationURL}
                                onChange={async (e) => {
                                  e.preventDefault();
                                  await handleChange(
                                    e.target.value,
                                    updateForm.destinationURL.key,
                                  );
                                }}
                              />
                            )}
                          </>
                        )}
                      </>
                    )}
                    {data?.type === "slider" && i.key === 2 && (
                      <>
                        <div className="d-flex flex-row align-items-center mt-2">
                          {!bannerLogoImage?.url && (
                            <Uploader
                              data={{
                                disabled: false,
                                isLable: true,
                                iconName: "upload-cloud",
                                fileSize: 6,
                              }}
                              onChange={onChangeBannerLogo}
                              loading={(value) =>
                                updateUploadSectionState("bannerLogo", {
                                  isLoading: value,
                                  uploadProgress: value ? 0 : 100,
                                })
                              }
                              progress={(value) =>
                                updateUploadSectionState("bannerLogo", {
                                  isLoading: true,
                                  uploadProgress: value,
                                })
                              }
                            />
                          )}
                          {bannerLogoImage?.url && (
                            <ImageComponent
                              // key={index}
                              data={{
                                size: "right-adv mb-2",
                                imgUrl: bannerLogoImage?.url,
                              }}
                              onClickRemove={() =>
                                onClickRemoveImage(
                                  bannerLogoImage?.file_name,
                                  "header",
                                  "bannerLogo",
                                  0,
                                )
                              }
                            />
                          )}
                          <div className="image-size-wrapper ml-2">
                            <span>Upload logo </span>(80x80 px)
                          </div>
                        </div>
                        <div className="image-size-wrapper mt-1 mb-1">
                          <span>Upload banner </span>(620x200 px)
                        </div>
                        <div className="d-flex flex-row align-items-center">
                          {!bannerImage?.url && (
                            <div
                              key={`placeholder`}
                              className="right-bar-adv-wrapper banner flex items-center justify-center text-gray-400 mr-2"
                            >
                              620x200
                            </div>
                          )}
                          {bannerImage?.url && (
                            <ImageComponent
                              // key={index}
                              data={{
                                size: "banner-ad mb-2",
                                imgUrl: bannerImage?.url,
                              }}
                              onClickRemove={() =>
                                onClickRemoveImage(
                                  bannerImage?.file_name,
                                  "header",
                                  "banner",
                                  0,
                                )
                              }
                            />
                          )}
                          {!bannerImage?.url && (
                            <Uploader
                              data={{
                                disabled: false,
                                isLable: true,
                                iconName: "upload-cloud",
                                width: 620,
                                height: 200,
                                fileSize: 6,
                              }}
                              onChange={onChangeBannerImage}
                              loading={(value) =>
                                updateUploadSectionState("bannerImage", {
                                  isLoading: value,
                                  uploadProgress: value ? 0 : 100,
                                })
                              }
                              progress={(value) =>
                                updateUploadSectionState("bannerImage", {
                                  isLoading: true,
                                  uploadProgress: value,
                                })
                              }
                            />
                          )}
                        </div>
                        <InputBox
                          data={updateForm.title}
                          onChange={async (e) => {
                            e.preventDefault();
                            await handleChange(
                              e.target.value,
                              updateForm.title.key,
                            );
                          }}
                        />

                        <InputBox
                          data={updateForm.description}
                          onChange={async (e) => {
                            e.preventDefault();
                            await handleChange(
                              e.target.value,
                              updateForm.description.key,
                            );
                          }}
                        />

                        {!data?.isAdmin && (
                          <InputBox
                            data={updateForm.destinationURL}
                            onChange={async (e) => {
                              e.preventDefault();
                              await handleChange(
                                e.target.value,
                                updateForm.destinationURL.key,
                              );
                            }}
                          />
                        )}

                        <DropBox
                          data={updateForm.buttonType}
                          onChange={(e) => {
                            const updateForm = { ...formData };
                            console.log({ e });
                            updateForm["buttonType"].value = e;
                            setFormData(updateForm);
                            // dispatch(setCategoryDetails(e));
                          }}
                        />
                      </>
                    )}
                    {i.key === 3 && (
                      <>
                        <div className="wpcw-sub-title">
                          Recommended size: 728 x 90 pixels · Accepted formats:
                          GIF · Max size: 8MB
                        </div>
                        <div className="d-flex flex-row align-items-center">
                          {data?.type === "slider" && (
                            <>
                              {gifImageRight?.url && (
                                <ImageComponent
                                  // key={index}
                                  data={{
                                    size: "right-adv mb-2",
                                    imgUrl: gifImageRight?.url,
                                  }}
                                  onClickRemove={() =>
                                    onClickRemoveImage(
                                      gifImageRight?.file_name,
                                      "right",
                                      "gifRight",
                                      0,
                                    )
                                  }
                                />
                              )}

                              {!gifRightUploadState.isLoading &&
                                !gifImageRight?.url && (
                                  <div
                                    key={`placeholder`}
                                    className="right-bar-adv-wrapper flex items-center justify-center text-gray-400 mr-2"
                                  >
                                    Ad 620x620
                                  </div>
                                )}
                              {gifRightUploadState.isLoading &&
                                gifRightUploadState.uploadProgress > 0 && (
                                  <Progress
                                    percent={gifRightUploadState.uploadProgress}
                                    status="active"
                                  />
                                )}
                              {!gifImageRight?.url && (
                                <Uploader
                                  data={{
                                    disabled: false,
                                    isLable: true,
                                    iconName: "upload-cloud",
                                    width: 620,
                                    height: 620,
                                    fileSize: 8,
                                  }}
                                  onChange={onChangeGifRight}
                                  loading={(value) =>
                                    updateUploadSectionState("gifRight", {
                                      isLoading: value,
                                      uploadProgress: value ? 0 : 100,
                                    })
                                  }
                                  progress={(value) =>
                                    updateUploadSectionState("gifRight", {
                                      isLoading: true,
                                      uploadProgress: value,
                                    })
                                  }
                                />
                              )}
                            </>
                          )}
                          {data?.type === "header" && (
                            <>
                              {gifImage?.url && (
                                <ImageComponent
                                  // key={index}
                                  data={{
                                    size: "header-ad-lg mb-2",
                                    imgUrl: gifImage?.url,
                                  }}
                                  onClickRemove={() =>
                                    onClickRemoveImage(
                                      gifImage?.file_name,
                                      "header",
                                      "gif",
                                      0,
                                    )
                                  }
                                />
                              )}

                              {!gifHeaderUploadState.isLoading &&
                                !gifImage?.url && (
                                  <div
                                    key={`placeholder`}
                                    className="header-bar-adv-wrapper mr-3"
                                  >
                                    Ad 720x90
                                  </div>
                                )}
                              {gifHeaderUploadState.isLoading &&
                                gifHeaderUploadState.uploadProgress > 0 && (
                                  <Progress
                                    percent={
                                      gifHeaderUploadState.uploadProgress
                                    }
                                    status="active"
                                  />
                                )}
                              {!gifImage?.url && (
                                <Uploader
                                  data={{
                                    disabled: false,
                                    isLable: true,
                                    iconName: "upload-cloud",
                                    width: 720,
                                    height: 90,
                                    fileSize: 8,
                                  }}
                                  onChange={onChangeGif}
                                  loading={(value) =>
                                    updateUploadSectionState("gifHeader", {
                                      isLoading: value,
                                      uploadProgress: value ? 0 : 100,
                                    })
                                  }
                                  progress={(value) =>
                                    updateUploadSectionState("gifHeader", {
                                      isLoading: true,
                                      uploadProgress: value,
                                    })
                                  }
                                />
                              )}
                            </>
                          )}
                        </div>

                        {!data?.isAdmin && (
                          <InputBox
                            data={updateForm.destinationURL}
                            onChange={async (e) => {
                              e.preventDefault();
                              await handleChange(
                                e.target.value,
                                updateForm.destinationURL.key,
                              );
                            }}
                          />
                        )}
                      </>
                    )}
                  </TabPane>
                ))}
            </Tabs>
          </div>
        </>
      )}
      {/* </div> */}
    </>
  );
};
export default withRouter(Index);
